import Typography, { TypographyProps } from "@mui/material/Typography";

interface LabelTextProps extends TypographyProps {
  text?: string;
}

export default function LabelText(props: LabelTextProps) {
  const { text, children, ...rest } = props;
  return (
    <Typography variant="subtitle2" {...rest}>
      {text || children}
    </Typography>
  );
}
